import { render, staticRenderFns } from "./EditFirmUser.vue?vue&type=template&id=47258f0a&scoped=true&"
import script from "./EditFirmUser.vue?vue&type=script&lang=js&"
export * from "./EditFirmUser.vue?vue&type=script&lang=js&"
import style0 from "./EditFirmUser.vue?vue&type=style&index=0&id=47258f0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47258f0a",
  null
  
)

export default component.exports